import { HeaderTitleService } from "@app/shared/common/header-title/header-title.service";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from "@angular/common/http";
import { ChatSignalrService } from "@app/shared/layout/chat/chat-signalr.service";
import { LinkAccountModalComponent } from "@app/shared/layout/link-account-modal.component";
import { LinkedAccountsModalComponent } from "@app/shared/layout/linked-accounts-modal.component";
import { UserDelegationsModalComponent } from "@app/shared/layout/user-delegations-modal.component";
import { CreateNewUserDelegationModalComponent } from "@app/shared/layout/create-new-user-delegation-modal.component";
import { LoginAttemptsModalComponent } from "@app/shared/layout/login-attempts-modal.component";
import { ChangePasswordModalComponent } from "@app/shared/layout/profile/change-password-modal.component";
import { ChangeProfilePictureModalComponent } from "@app/shared/layout/profile/change-profile-picture-modal.component";
import { MySettingsModalComponent } from "@app/shared/layout/profile/my-settings-modal.component";
import { SmsVerificationModalComponent } from "@app/shared/layout/profile/sms-verification-modal.component";
import { ServiceProxyModule } from "@shared/service-proxies/service-proxy.module";
import { UtilsModule } from "@shared/utils/utils.module";
import { FileUploadModule } from "ng2-file-upload";
import { ModalModule } from "ngx-bootstrap/modal";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { FileUploadModule as PrimeNgFileUploadModule } from "primeng/fileupload";
import { PaginatorModule } from "primeng/paginator";
import { ProgressBarModule } from "primeng/progressbar";
import { TableModule } from "primeng/table";
import { ImpersonationService } from "./admin/users/impersonation.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DefaultLayoutComponent } from "./shared/layout/themes/default/default-layout.component";
import { Theme2LayoutComponent } from "./shared/layout/themes/theme2/theme2-layout.component";
import { Theme3LayoutComponent } from "./shared/layout/themes/theme3/theme3-layout.component";
import { Theme4LayoutComponent } from "./shared/layout/themes/theme4/theme4-layout.component";
import { Theme5LayoutComponent } from "./shared/layout/themes/theme5/theme5-layout.component";
import { Theme6LayoutComponent } from "./shared/layout/themes/theme6/theme6-layout.component";
import { Theme9LayoutComponent } from "./shared/layout/themes/theme9/theme9-layout.component";
import { Theme7LayoutComponent } from "./shared/layout/themes/theme7/theme7-layout.component";
import { Theme8LayoutComponent } from "./shared/layout/themes/theme8/theme8-layout.component";
import { Theme10LayoutComponent } from "./shared/layout/themes/theme10/theme10-layout.component";
import { Theme11LayoutComponent } from "./shared/layout/themes/theme11/theme11-layout.component";
import { AppCommonModule } from "./shared/common/app-common.module";
import { ChatBarComponent } from "./shared/layout/chat/chat-bar.component";
import { ThemeSelectionPanelComponent } from "./shared/layout/theme-selection/theme-selection-panel.component";
import { ChatFriendListItemComponent } from "./shared/layout/chat/chat-friend-list-item.component";
import { ChatMessageComponent } from "./shared/layout/chat/chat-message.component";
import { PendingTimesheetReminderModule } from "./main/pending-timesheet-reminder/pending-timesheet-reminder.module";
import { FooterComponent } from "./shared/layout/footer.component";
import { LinkedAccountService } from "./shared/layout/linked-account.service";
import { SideBarMenuComponent } from "./shared/layout/nav/side-bar-menu.component";
import { TopBarMenuComponent } from "./shared/layout/nav/top-bar-menu.component";
import { SuperAdminTopBarMenuComponent } from "./shared/layout/nav/super-admin-top-bar-menu.component";
import { SuperAdminTopbarComponent } from "./shared/layout/topbar/super-admin-topbar/super-admin-topbar.component";
import { QuickThemeSelectionComponent } from "./shared/layout/topbar/quick-theme-selection.component";
import { ThemeModeToggleComponent } from "./shared/layout/topbar/theme-mode-toggle.component";
import { LanguageSwitchDropdownComponent } from "./shared/layout/topbar/language-switch-dropdown.component";
import { ChatToggleButtonComponent } from "./shared/layout/topbar/chat-toggle-button.component";
import { SubscriptionNotificationBarComponent } from "./shared/layout/topbar/subscription-notification-bar.component";
import { UserMenuComponent } from "./shared/layout/topbar/user-menu.component";
import { DefaultBrandComponent } from "./shared/layout/themes/default/default-brand.component";
import { Theme2BrandComponent } from "./shared/layout/themes/theme2/theme2-brand.component";
import { Theme3BrandComponent } from "./shared/layout/themes/theme3/theme3-brand.component";
import { Theme4BrandComponent } from "./shared/layout/themes/theme4/theme4-brand.component";
import { Theme5BrandComponent } from "./shared/layout/themes/theme5/theme5-brand.component";
import { Theme6BrandComponent } from "./shared/layout/themes/theme6/theme6-brand.component";
import { Theme7BrandComponent } from "./shared/layout/themes/theme7/theme7-brand.component";
import { Theme8BrandComponent } from "./shared/layout/themes/theme8/theme8-brand.component";
import { Theme9BrandComponent } from "./shared/layout/themes/theme9/theme9-brand.component";
import { Theme10BrandComponent } from "./shared/layout/themes/theme10/theme10-brand.component";
import { Theme11BrandComponent } from "./shared/layout/themes/theme11/theme11-brand.component";
import { UserNotificationHelper } from "./shared/layout/notifications/UserNotificationHelper";
import { HeaderNotificationsComponent } from "./shared/layout/notifications/header-notifications.component";
import { ScrollerModule } from "primeng/scroller";
import { NotificationSettingsModalComponent } from "./shared/layout/notifications/notification-settings-modal.component";
import { NotificationsComponent } from "./shared/layout/notifications/notifications.component";
import { TextMaskModule } from "@shared/compat";
import { ImageCropperModule } from "@shared/compat";
import { ActiveDelegatedUsersComboComponent } from "./shared/layout/topbar/active-delegated-users-combo.component";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { CoreModule } from "@metronic/app/core/core.module";
import { SessionTimeoutModalComponent } from "./shared/common/session-timeout/session-timeout-modal-component";
import { SessionTimeoutComponent } from "./shared/common/session-timeout/session-timeout.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { MenuSearchBarComponent } from "./shared/layout/nav/menu-search-bar/menu-search-bar.component";
import { UniversalSearchComponent } from "./shared/layout/nav/universal-search/universal-search.component";
import { HighlightSearchPipe } from "./shared/layout/nav/universal-search/highlight-search.pipe";
import { NgxSpinnerModule } from "ngx-spinner";
import { ScrollTopComponent } from "./shared/layout/scroll-top.component";
import { AppBsModalModule } from "@shared/common/appBsModal/app-bs-modal.module";
import { DownloadFileComponent } from "./shared/layout/topbar/download-file/download-file.component";
import { MyProfileComponent } from "./shared/layout/topbar/my-profile/my-profile.component";
import { ProfileIntegrationsModule } from "./shared/layout/topbar/my-profile/integrations/profile-integrations.module";
import { DropdownPopComponent } from "./shared/layout/topbar/dropdown-pop/dropdown-pop.component";
import { SettingTopbarComponent } from "./shared/layout/topbar/setting-topbar/setting-topbar.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { GooglePlaceModule } from "@shared/compat";
import { ToastModule } from "primeng/toast";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from "@shared/compat";
import { BrowserModule } from "@angular/platform-browser";
import { DateFormatPipe } from "../shared/common/pipes/date-format.pipe";
import { INTIMECommonModule } from "../shared/common/common.module";
import { TooltipModule as PrimeNgTooltipModule } from "primeng/tooltip";
import { DrawerModule } from "primeng/drawer";
import { NgxShimmerLoadingModule } from "ngx-shimmer-loading";
import { HelpSectionComponent } from "./main/common-ui-elements/help-section/help-section.component";
import { HelpSectionContentComponent } from "./main/common-ui-elements/help-section-content/help-section-content.component";
import { HelpMenuComponent } from "./shared/layout/topbar/setting-topbar/help-menu.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ReleaseNotesComponent } from "./shared/layout/release-notes/release-notes.component";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
};

@NgModule({
    declarations: [
        AppComponent,
        DefaultLayoutComponent,
        Theme2LayoutComponent,
        Theme3LayoutComponent,
        Theme4LayoutComponent,
        Theme5LayoutComponent,
        Theme6LayoutComponent,
        Theme7LayoutComponent,
        Theme8LayoutComponent,
        Theme9LayoutComponent,
        Theme10LayoutComponent,
        Theme11LayoutComponent,
        HeaderNotificationsComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        SuperAdminTopBarMenuComponent,
        SuperAdminTopbarComponent,
        FooterComponent,
        ScrollTopComponent,
        LoginAttemptsModalComponent,
        LinkedAccountsModalComponent,
        UserDelegationsModalComponent,
        CreateNewUserDelegationModalComponent,
        LinkAccountModalComponent,
        ChangePasswordModalComponent,
        ChangeProfilePictureModalComponent,
        MySettingsModalComponent,
        SmsVerificationModalComponent,
        NotificationsComponent,
        ChatBarComponent,
        ThemeSelectionPanelComponent,
        ChatFriendListItemComponent,
        NotificationSettingsModalComponent,
        ChatMessageComponent,
        QuickThemeSelectionComponent,
        ThemeModeToggleComponent,
        LanguageSwitchDropdownComponent,
        ChatToggleButtonComponent,
        SubscriptionNotificationBarComponent,
        UserMenuComponent,
        DefaultBrandComponent,
        Theme2BrandComponent,
        Theme3BrandComponent,
        Theme4BrandComponent,
        Theme5BrandComponent,
        Theme6BrandComponent,
        Theme7BrandComponent,
        Theme8BrandComponent,
        Theme9BrandComponent,
        Theme10BrandComponent,
        Theme11BrandComponent,
        SessionTimeoutModalComponent,
        SessionTimeoutComponent,
        MenuSearchBarComponent,
        UniversalSearchComponent,
        HighlightSearchPipe,
        ActiveDelegatedUsersComboComponent,
        DownloadFileComponent,
        MyProfileComponent,
        DropdownPopComponent,
        SettingTopbarComponent,
        HelpSectionComponent,
        HelpSectionContentComponent,
        HelpMenuComponent,
    ],
    imports: [
        ToastModule,
        CommonModule,
        FormsModule,
        ScrollerModule,
        NgxShimmerLoadingModule,
        ModalModule,
        TooltipModule,
        TabsModule,
        BsDropdownModule,
        PopoverModule,
        BsDatepickerModule,
        FileUploadModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ProfileIntegrationsModule,
        ServiceProxyModule,
        TableModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressBarModule,
        PerfectScrollbarModule,
        CoreModule,
        TextMaskModule,
        ImageCropperModule,
        AutoCompleteModule,
        NgxSpinnerModule,
        AppBsModalModule,
        NgSelectModule,
        ReactiveFormsModule,
        ToastrModule.forRoot({ positionClass: "toast-bottom-right", preventDuplicates: true }),
        GooglePlaceModule,
        NgbModule,
        BrowserModule,
        INTIMECommonModule,
        PrimeNgTooltipModule,
        DrawerModule,
        BrowserAnimationsModule,
        PendingTimesheetReminderModule,
        ReleaseNotesComponent,
    ],
    providers: [
        DatePipe,
        ImpersonationService,
        LinkedAccountService,
        UserNotificationHelper,
        ChatSignalrService,
        HeaderTitleService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },
        { provide: ToastrService, useClass: ToastrService },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ],
})
export class AppModule {}
